import React from 'react';
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
    MDBBadge,
} from 'mdb-react-ui-kit';
import axios from 'axios';
import { baseURL } from '../api/baseURL';
import Loader from '../Loader';
import Modal from '../Modal';
import { connect } from 'react-redux';
import AdminShell from './layout/AdminShell';

// ===================== OLD HARDCODED State type (Change 71 Part 2 - commented) =====================
// type State = {
//     requested: boolean,
//     err: boolean,
//     photoOpen: boolean,
//     modalOpen: boolean,
//     basicModal: boolean,
//     personal_photographer: number,
//     cinematographer: number,
//     cinematographer_for_reels: number,
//     reels_video_editing: number,
// };

type HourTier = { hours: number, total: number };

type ServiceItem = {
    _id: string,
    key: string,
    name: string,
    specialization_name: string,
    price_per_hour: number,
    // Admin-editable bulk-hour discount total per hour count (1-6 hr) for
    // what the CUSTOMER pays — e.g. 2hr might total less than 2x the 1hr
    // price. Falls back to Backend's hardcoded DEFAULT_TIER_TABLE (by name
    // match) when empty; price_per_hour is still used for below-min
    // pro-rating and above-max linear extension. This field already existed
    // server-side but had no Admin UI until now.
    hour_tiers: HourTier[],
    // Admin-editable photographer payout tiers for this service — a manually
    // typed total per hour count (1-6 hr), same shape as hour_tiers above but
    // for what the photographer earns. No rate-times-hours math anywhere;
    // whatever admin types for that hour count is what's shown/suggested.
    // Falls back to Backend's hardcoded DEFAULT_PAYOUT_TABLE when empty.
    payout_hour_tiers: HourTier[],
    // Photographer payout for a per_count service (e.g. "Editing Reels") —
    // a flat ₹ per unit, deliberately a SEPARATE field from payout_hour_tiers
    // rather than a fake {hours:1} entry: the real payout-suggestion engine
    // (Backend payoutTiers.js / Admin Server payment.js) keys off actual
    // booking HOURS for anything in payout_hour_tiers, so a per-count service
    // stored there would get its shoot-duration hours matched against tier
    // "1" and produce a wrong suggested payout — this field is never read by
    // that hour-based code, only by this per_count display/edit UI.
    payout_price_per_unit: number | null,
    pricing_type: string,
    description: string,
    is_active: boolean,
    hide_for_categories: string[],
};

const PAYOUT_TIER_HOURS = [1, 2, 3, 4, 5, 6];

// Same hardcoded fallback table + substring-matching approach as
// Backend/src/helpers/payoutTiers.js's DEFAULT_PAYOUT_TABLE and
// Photographer/src/screens/PayoutRatesScreen.tsx's PAYOUT_DATA (duplicated
// here too — separate app/deployment, same as those two). Used only to
// PREFILL the Photographer Payout inputs when a service has no
// payout_hour_tiers configured yet, so admin sees the same numbers a
// photographer is currently shown instead of blank fields.
const DEFAULT_PAYOUT_TABLE: { matches: string[], tiers: Record<number, number> }[] = [
    { matches: ['photoshoot', 'personalphotographer', 'traditionalphotographer'], tiers: { 1: 1000, 2: 1800, 3: 2600, 4: 3500, 5: 4300, 6: 5100 } },
    { matches: ['candid', 'candidphotographer'], tiers: { 1: 2500, 2: 4000, 3: 5000, 4: 7000, 5: 9000, 6: 11000 } },
    { matches: ['reelsiphone', 'iphonereels', 'iphonereel', 'reeliphone'], tiers: { 1: 1200, 2: 2000, 3: 2800, 4: 3800, 5: 4800, 6: 5800 } },
    { matches: ['reelsdslr', 'dslrreels', 'dslrreel', 'reeldslr', 'cinematographerforreels', 'cinematographer'], tiers: { 1: 1800, 2: 2600, 3: 3700, 4: 5000, 5: 6100, 6: 7200 } },
];

function normaliseToken(input: any): string {
    return String(input || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function findDefaultPayoutTiers(key: string, specializationName: string): Record<number, number> | null {
    const nameKey = normaliseToken(key);
    const specKey = normaliseToken(specializationName);
    for (const entry of DEFAULT_PAYOUT_TABLE) {
        if (entry.matches.some((m) => nameKey.includes(m) || specKey.includes(m))) {
            return entry.tiers;
        }
    }
    return null;
}

type State = {
    requested: boolean,
    err: boolean,
    services: ServiceItem[],
    // Add/Edit form
    editMode: boolean,
    editServiceId: string,
    formKey: string,
    formName: string,
    formSpecializationName: string,
    formPricePerHour: string,
    formHourTiers: { [hours: number]: string },
    formPayoutTiers: { [hours: number]: string },
    formPayoutPricePerUnit: string,
    formPricingType: string,
    formDescription: string,
    formHideForCategories: string,
    formIsActive: boolean,
    showAddEditModal: boolean,
    showDeleteConfirm: boolean,
    deleteServiceId: string,
};

class Services extends React.Component<{ serviceData?: any, token?: string }> {

    state: State = {
        requested: false,
        err: false,
        services: [],
        editMode: false,
        editServiceId: '',
        formKey: '',
        formName: '',
        formSpecializationName: '',
        formPricePerHour: '',
        formHourTiers: {},
        formPayoutTiers: {},
        formPayoutPricePerUnit: '',
        formPricingType: 'per_hour',
        formDescription: '',
        formHideForCategories: '',
        formIsActive: true,
        showAddEditModal: false,
        showDeleteConfirm: false,
        deleteServiceId: '',
    }

    // ===================== OLD HARDCODED updateServicePricing (Change 71 Part 2 - commented) =====================
    // updateServicePricing = () => {
    //     if (!this.state.requested) {
    //         this.setState({ err: false, requested: true });
    //         axios.post(`${baseURL}/update-service-pricing`,
    //             {
    //                 personal_photographer: (this.state.personal_photographer || this.props.serviceData?.personal_photographer),
    //                 cinematographer: (this.state.cinematographer || this.props.serviceData?.cinematographer),
    //                 cinematographer_for_reels: (this.state.cinematographer_for_reels || this.props.serviceData?.cinematographer_for_reels),
    //                 reels_video_editing: (this.state.reels_video_editing || this.props.serviceData?.reels_video_editing)
    //             },
    //             {
    //                 headers: { Authorization: `Bearer ${this.props.token}` }
    //             })
    //             .then((response: any) => {
    //                 if (response?.data?.message === "success") {
    //                     window.location.reload();
    //                 }
    //                 else {
    //                     this.setState({ err: true, requested: false });
    //                 }
    //             })
    //             .catch((error: any) => {
    //                 this.setState({ err: true, requested: false });
    //             })
    //     }
    // }

    // ===================== NEW DYNAMIC SERVICES METHODS (Change 71 Part 2) =====================

    componentDidMount(): void {
        this.fetchServices();
    }

    fetchServices = () => {
        this.setState({ requested: true });
        axios.get(`${baseURL}/services`, {
            headers: { Authorization: `Bearer ${this.props.token}` }
        })
        .then((response: any) => {
            this.setState({ services: response?.data?.services || [], requested: false });
        })
        .catch(() => {
            this.setState({ err: true, requested: false });
        });
    }

    openAddModal = () => {
        this.setState({
            showAddEditModal: true,
            editMode: false,
            editServiceId: '',
            formKey: '',
            formName: '',
            formSpecializationName: '',
            formPricePerHour: '',
            formHourTiers: {},
            formPayoutTiers: {},
            formPayoutPricePerUnit: '',
            formPricingType: 'per_hour',
            formDescription: '',
            formHideForCategories: '',
            formIsActive: true,
        });
    }

    openEditModal = (service: ServiceItem) => {
        const buildTierMap = (tiers?: HourTier[]): { [hours: number]: string } => {
            const map: { [hours: number]: string } = {};
            (tiers || []).forEach((t: HourTier) => { map[t.hours] = String(t.total); });
            return map;
        };
        // Prefill Photographer Payout with the same numbers currently shown
        // on the SnapMaster app's Payout Rates tab (the hardcoded fallback
        // table) when nothing's configured yet — so admin edits real
        // starting values instead of blank fields.
        let payoutTierMap = buildTierMap(service.payout_hour_tiers);
        if (Object.keys(payoutTierMap).length === 0 && service.pricing_type !== 'per_count') {
            const defaults = findDefaultPayoutTiers(service.key, service.specialization_name);
            if (defaults) {
                payoutTierMap = Object.fromEntries(
                    Object.entries(defaults).map(([h, total]) => [h, String(total)])
                );
            }
        }
        this.setState({
            showAddEditModal: true,
            editMode: true,
            editServiceId: service._id,
            formKey: service.key,
            formName: service.name,
            formSpecializationName: service.specialization_name,
            formPricePerHour: String(service.price_per_hour),
            formHourTiers: buildTierMap(service.hour_tiers),
            formPayoutTiers: payoutTierMap,
            formPayoutPricePerUnit: service.payout_price_per_unit != null ? String(service.payout_price_per_unit) : '',
            formPricingType: service.pricing_type,
            formDescription: service.description || '',
            formHideForCategories: (service.hide_for_categories || []).join(', '),
            formIsActive: service.is_active,
        });
    }

    closeAddEditModal = () => {
        this.setState({ showAddEditModal: false });
    }

    submitService = () => {
        if (this.state.requested) return;
        this.setState({ requested: true, err: false });

        const hideArr = this.state.formHideForCategories
            ? this.state.formHideForCategories.split(',').map((s: string) => s.trim()).filter(Boolean)
            : [];

        const payoutTiersArr: HourTier[] = PAYOUT_TIER_HOURS
            .filter((h) => this.state.formPayoutTiers[h])
            .map((h) => ({ hours: h, total: Number(this.state.formPayoutTiers[h]) }));
        const hourTiersArr: HourTier[] = PAYOUT_TIER_HOURS
            .filter((h) => this.state.formHourTiers[h])
            .map((h) => ({ hours: h, total: Number(this.state.formHourTiers[h]) }));
        const payoutPricePerUnit = this.state.formPayoutPricePerUnit
            ? Number(this.state.formPayoutPricePerUnit)
            : null;

        if (this.state.editMode) {
            // UPDATE existing service
            axios.post(`${baseURL}/update-service`, {
                serviceId: this.state.editServiceId,
                updates: {
                    name: this.state.formName,
                    specialization_name: this.state.formSpecializationName,
                    price_per_hour: Number(this.state.formPricePerHour),
                    hour_tiers: hourTiersArr,
                    payout_hour_tiers: payoutTiersArr,
                    payout_price_per_unit: payoutPricePerUnit,
                    pricing_type: this.state.formPricingType,
                    description: this.state.formDescription,
                    is_active: this.state.formIsActive,
                    hide_for_categories: hideArr,
                }
            }, {
                headers: { Authorization: `Bearer ${this.props.token}` }
            })
            .then((response: any) => {
                if (response?.data?.message === "success") {
                    this.setState({ showAddEditModal: false, requested: false });
                    this.fetchServices();
                } else {
                    this.setState({ err: true, requested: false });
                }
            })
            .catch(() => {
                this.setState({ err: true, requested: false });
            });
        } else {
            // ADD new service
            axios.post(`${baseURL}/add-service`, {
                key: this.state.formKey,
                name: this.state.formName,
                specialization_name: this.state.formSpecializationName,
                price_per_hour: Number(this.state.formPricePerHour),
                hour_tiers: hourTiersArr,
                payout_hour_tiers: payoutTiersArr,
                payout_price_per_unit: payoutPricePerUnit,
                pricing_type: this.state.formPricingType,
                description: this.state.formDescription,
                hide_for_categories: hideArr,
            }, {
                headers: { Authorization: `Bearer ${this.props.token}` }
            })
            .then((response: any) => {
                if (response?.data?.message === "success") {
                    this.setState({ showAddEditModal: false, requested: false });
                    this.fetchServices();
                } else {
                    this.setState({ err: true, requested: false });
                }
            })
            .catch(() => {
                this.setState({ err: true, requested: false });
            });
        }
    }

    confirmDelete = (serviceId: string) => {
        this.setState({ showDeleteConfirm: true, deleteServiceId: serviceId });
    }

    doDelete = () => {
        if (this.state.requested) return;
        this.setState({ requested: true, showDeleteConfirm: false });
        axios.post(`${baseURL}/delete-service`, {
            serviceId: this.state.deleteServiceId,
        }, {
            headers: { Authorization: `Bearer ${this.props.token}` }
        })
        .then((response: any) => {
            if (response?.data?.message === "success") {
                this.setState({ requested: false });
                this.fetchServices();
            } else {
                this.setState({ err: true, requested: false });
            }
        })
        .catch(() => {
            this.setState({ err: true, requested: false });
        });
    }

    toggleActive = (service: ServiceItem) => {
        if (this.state.requested) return;
        this.setState({ requested: true });
        axios.post(`${baseURL}/update-service`, {
            serviceId: service._id,
            updates: { is_active: !service.is_active }
        }, {
            headers: { Authorization: `Bearer ${this.props.token}` }
        })
        .then((response: any) => {
            if (response?.data?.message === "success") {
                this.setState({ requested: false });
                this.fetchServices();
            } else {
                this.setState({ err: true, requested: false });
            }
        })
        .catch(() => {
            this.setState({ err: true, requested: false });
        });
    }

    toggleModal = () => {
        if (this.state.err) {
            this.setState({ err: false });
        }
    }

    render() {
        return (
            <AdminShell activePage="services" title="Services" subtitle="Pricing, payout tiers, and availability per service">
                <Modal open={this.state.err} hideSec primaryText="Okay" title='Update' onConfirm={this.toggleModal} toggleOpen={this.toggleModal} content={<h6>Something went wrong, please try again later</h6>} />
                {this.state.requested ? <Loader /> : null}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <h4 className="card-title" style={{ margin: 0 }}>Services {this.state.services.length ? `(${this.state.services.length})` : ''}</h4>
                    <MDBBtn color='success' size='sm' onClick={this.openAddModal}>+ Add New Service</MDBBtn>
                </div>

                {this.state.services.length === 0 ? (
                    <div className="card"><div className="card-body" style={{ textAlign: 'center', color: '#999' }}>No services found. Add one!</div></div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 16 }}>
                        {this.state.services.map((svc: ServiceItem) => {
                            const hourTierByH = new Map((svc.hour_tiers || []).map((t) => [t.hours, t.total]));
                            const payoutTierByH = new Map((svc.payout_hour_tiers || []).map((t) => [t.hours, t.total]));
                            const isPerCount = svc.pricing_type === 'per_count';
                            // Same SnapMaster-payout-tab fallback used to prefill the edit
                            // form — shown here too (dimmed + labeled) so the card reflects
                            // what a photographer actually sees today, not a blank "—".
                            const defaultPayoutTiers = isPerCount ? null : findDefaultPayoutTiers(svc.key, svc.specialization_name);
                            const effectivePayout = (h: number): { value: number | null, isDefault: boolean } => {
                                if (payoutTierByH.has(h)) return { value: payoutTierByH.get(h)!, isDefault: false };
                                if (defaultPayoutTiers && defaultPayoutTiers[h] != null) return { value: defaultPayoutTiers[h], isDefault: true };
                                return { value: null, isDefault: false };
                            };
                            return (
                                <div className="card" key={svc._id}>
                                    <div className="card-body">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                                            <div>
                                                <div style={{ fontWeight: 800, fontSize: 14 }}>{svc.name}</div>
                                                <div style={{ fontSize: 11, opacity: 0.6 }}>{svc.specialization_name} · {svc.pricing_type}</div>
                                            </div>
                                            <MDBBadge color={svc.is_active ? 'success' : 'danger'} pill style={{ cursor: 'pointer' }} onClick={() => this.toggleActive(svc)}>
                                                {svc.is_active ? 'Active' : 'Inactive'}
                                            </MDBBadge>
                                        </div>

                                        {isPerCount ? (
                                            <div style={{ fontSize: 13, marginBottom: 12, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                <div><span style={{ opacity: 0.65 }}>Customer pays per unit: </span><span style={{ fontWeight: 700 }}>₹{svc.price_per_hour}</span></div>
                                                <div>
                                                    <span style={{ opacity: 0.65 }}>Photographer earns per unit: </span>
                                                    {svc.payout_price_per_unit != null ? (
                                                        <span style={{ fontWeight: 700 }}>₹{svc.payout_price_per_unit}</span>
                                                    ) : (
                                                        <span style={{ opacity: 0.5, fontStyle: 'italic' }}>Not set</span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{ overflowX: 'auto', marginBottom: 12 }}>
                                                <table style={{ width: '100%', fontSize: 11.5, borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ textAlign: 'right' }}>
                                                            <th style={{ textAlign: 'left', fontWeight: 700, opacity: 0.5, padding: '4px 6px' }}> </th>
                                                            {PAYOUT_TIER_HOURS.map((h) => (
                                                                <th key={h} style={{ padding: '4px 6px', fontWeight: 700, opacity: 0.5 }}>{h}hr</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ padding: '4px 6px', opacity: 0.7 }}>Customer pays</td>
                                                            {PAYOUT_TIER_HOURS.map((h) => (
                                                                <td key={h} style={{ padding: '4px 6px', textAlign: 'right' }}>
                                                                    {hourTierByH.has(h) ? `₹${hourTierByH.get(h)}` : <span style={{ opacity: 0.35 }}>—</span>}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                        <tr>
                                                            <td style={{ padding: '4px 6px', opacity: 0.7 }}>Photographer earns</td>
                                                            {PAYOUT_TIER_HOURS.map((h) => {
                                                                const { value, isDefault } = effectivePayout(h);
                                                                return (
                                                                    <td key={h} style={{ padding: '4px 6px', textAlign: 'right', opacity: isDefault ? 0.6 : 1, fontStyle: isDefault ? 'italic' : 'normal' }}>
                                                                        {value != null ? `₹${value}` : <span style={{ opacity: 0.35 }}>—</span>}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                        <tr>
                                                            <td style={{ padding: '4px 6px', opacity: 0.5, fontStyle: 'italic' }}>Margin</td>
                                                            {PAYOUT_TIER_HOURS.map((h) => {
                                                                const cust = hourTierByH.get(h);
                                                                const { value: pay } = effectivePayout(h);
                                                                if (cust == null || pay == null) {
                                                                    return <td key={h} style={{ padding: '4px 6px', textAlign: 'right', opacity: 0.35 }}>—</td>;
                                                                }
                                                                const margin = cust - pay;
                                                                const pct = cust > 0 ? Math.round((margin / cust) * 100) : 0;
                                                                return (
                                                                    <td key={h} style={{ padding: '4px 6px', textAlign: 'right', color: pct >= 25 ? '#5cb85c' : '#f0ad4e' }}>
                                                                        ₹{margin} ({pct}%)
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <p style={{ fontSize: 10, opacity: 0.45, marginTop: 4, marginBottom: 0 }}>
                                                    Customer pays "—" = not set, falls back to the default pricing table. Photographer earns <i>italic</i> = SnapMaster's current default rate, not yet explicitly set by an admin.
                                                </p>
                                            </div>
                                        )}

                                        <div style={{ display: 'flex', gap: 8 }}>
                                            <MDBBtn size='sm' color='info' onClick={() => this.openEditModal(svc)}>Edit</MDBBtn>
                                            <MDBBtn size='sm' color='danger' onClick={() => this.confirmDelete(svc._id)}>Delete</MDBBtn>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ===================== Add/Edit Service Modal ===================== */}
                <MDBModal open={this.state.showAddEditModal} onClose={this.closeAddEditModal} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{this.state.editMode ? 'Edit Service' : 'Add New Service'}</MDBModalTitle>
                            </MDBModalHeader>
                            <MDBModalBody>
                                {!this.state.editMode && (
                                    <>
                                        <MDBInput contrast label="Service Key (e.g. personal_photographer)" type="text" value={this.state.formKey} onChange={(e) => this.setState({ formKey: e.target.value })} />
                                        <br />
                                    </>
                                )}
                                <MDBInput contrast label="Display Name" type="text" value={this.state.formName} onChange={(e) => this.setState({ formName: e.target.value })} />
                                <br />
                                <MDBInput contrast label="Specialization Name (for photographer matching)" type="text" value={this.state.formSpecializationName} onChange={(e) => this.setState({ formSpecializationName: e.target.value })} />
                                <br />
                                <MDBInput contrast label="Customer Price per Hour/Count (₹)" type="number" value={this.state.formPricePerHour} onChange={(e) => this.setState({ formPricePerHour: e.target.value })} />
                                <br />
                                {this.state.formPricingType === 'per_count' ? (
                                    <>
                                        <MDBInput
                                            contrast
                                            label="Photographer Earns per Unit (₹)"
                                            type="number"
                                            value={this.state.formPayoutPricePerUnit}
                                            onChange={(e) => this.setState({ formPayoutPricePerUnit: e.target.value })}
                                        />
                                        <br />
                                    </>
                                ) : null}
                                <div style={{ marginBottom: 15 }}>
                                    <label style={{ color: '#999', fontSize: 12, marginBottom: 5, display: 'block' }}>
                                        Customer Pays (₹) — bulk-discount total per hour count, leave blank to use the default table
                                    </label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {PAYOUT_TIER_HOURS.map((h) => (
                                            <div key={h} style={{ width: 90 }}>
                                                <MDBInput
                                                    contrast
                                                    label={`${h} hr`}
                                                    type="number"
                                                    value={this.state.formHourTiers[h] || ''}
                                                    onChange={(e) => this.setState({
                                                        formHourTiers: { ...this.state.formHourTiers, [h]: e.target.value }
                                                    })}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <br />
                                <div style={{ marginBottom: 15 }}>
                                    <label style={{ color: '#999', fontSize: 12, marginBottom: 5, display: 'block' }}>
                                        Photographer Payout (₹) — total per hour count, leave blank to use the default table
                                    </label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {PAYOUT_TIER_HOURS.map((h) => (
                                            <div key={h} style={{ width: 90 }}>
                                                <MDBInput
                                                    contrast
                                                    label={`${h} hr`}
                                                    type="number"
                                                    value={this.state.formPayoutTiers[h] || ''}
                                                    onChange={(e) => this.setState({
                                                        formPayoutTiers: { ...this.state.formPayoutTiers, [h]: e.target.value }
                                                    })}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <br />
                                <div style={{ marginBottom: 15 }}>
                                    <label style={{ color: '#999', fontSize: 12, marginBottom: 5, display: 'block' }}>Pricing Type</label>
                                    <select value={this.state.formPricingType} onChange={(e) => this.setState({ formPricingType: e.target.value })} style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #555', backgroundColor: '#333', color: '#fff' }}>
                                        <option value="per_hour">Per Hour</option>
                                        <option value="per_count">Per Count</option>
                                    </select>
                                </div>
                                <MDBInput contrast label="Description (optional, shown to customer)" type="text" value={this.state.formDescription} onChange={(e) => this.setState({ formDescription: e.target.value })} />
                                <br />
                                <MDBInput contrast label="Hide for Categories (comma-separated, e.g. Video Reels)" type="text" value={this.state.formHideForCategories} onChange={(e) => this.setState({ formHideForCategories: e.target.value })} />
                                <br />
                                {this.state.editMode && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <input type="checkbox" checked={this.state.formIsActive} onChange={(e) => this.setState({ formIsActive: e.target.checked })} />
                                        <label style={{ color: '#ccc' }}>Active</label>
                                    </div>
                                )}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={this.closeAddEditModal}>Cancel</MDBBtn>
                                <MDBBtn onClick={this.submitService}>{this.state.editMode ? 'Update' : 'Add'}</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                {/* ===================== Delete Confirmation Modal ===================== */}
                <MDBModal open={this.state.showDeleteConfirm} onClose={() => this.setState({ showDeleteConfirm: false })} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Confirm Delete</MDBModalTitle>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to delete this service? This action cannot be undone.</p>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={() => this.setState({ showDeleteConfirm: false })}>Cancel</MDBBtn>
                                <MDBBtn color='danger' onClick={this.doDelete}>Delete</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

            </AdminShell>
        );
    }
}


const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        token: state.auth.token
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);